import { useAppDispatch } from "../../../../../redux/hooks";
import { useNavigate } from "react-router-dom";

import { AssignedCarsNodeDataInterface } from "../../../../../redux/interfaces/fleet.interface";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import { setFleetAssignedCarToNode } from "../../../../../redux/reducer/fleet.reducer";
import { fleetRoutes } from "../../../../../router/routesConstants";

function AssignCarsToNodeActionButton({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: AssignedCarsNodeDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleTransferCar = () => {
    dispatch(setFleetAssignedCarToNode(crudData));
    navigate(`/${fleetRoutes.assignedCarNode}/transfer/${itemId}`);
  };

  // const handleRemoveAssignedCar = async () => {
  //   const resultAction = await dispatch(
  //     postRemoveAssignedCar({ id_flota_nod: itemId }),
  //   );

  //   if (
  //     checkEndpointStatus(resultAction, postRemoveAssignedCar) ===
  //     endpointStatus.fulfilled
  //   ) {
  //     if (
  //       tableContext.tablePagination.page &&
  //       tableContext.tablePagination.rowsPerPage
  //     ) {
  //       dispatch(
  //         fetchAssignedCarsNode({
  //           page: tableContext.tablePagination.page,
  //           perPage: tableContext.tablePagination.rowsPerPage,
  //           nrauto: tableContext.tableSearch.nrauto,
  //           id_nod: tableContext.tableSearch.id_nod,
  //         }),
  //       );
  //     }
  //   }
  // };

  return (
    <ActionMenu
      items={[
        {
          id: "transfer-car",
          label: "Transfer masina",
          icon: "TRANSFER",
          tooltip: "Deschide transferul masinii catre alt nod.",
          onClick: handleTransferCar,
        },
      ]}
      title={crudData.nrauto}
      ariaLabel={`Actiuni pentru masina ${crudData.nrauto}`}
    />
  );
}

export default AssignCarsToNodeActionButton;
